import React, { useState } from "react";
import {
  Grid,
  Button,
  TextField,
  Typography,
  Alert,
  Snackbar,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import axios from "../axios";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { connect } from "react-redux";
import { login } from "../store/actions/authActions";
import { useThemeContext } from "../context/ThemeContext";
import Navbar from "../Components/Navbar"
import { Person as PersonIcon } from "@mui/icons-material";
import ChangePassword from "./ChangePassword";

let initialValues = {
  email: "",
  password: "",
};
let SignInSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required!"),
  password: Yup.string().required("Password is required!").min(3).max(20),
});
const url = process.env.REACT_APP_BE_URL;

const fieldStyles = {
  width: "100%",
  marginBottom: "10px",
};

const formStyles = {
  display: "flex",
  flexDirection: "column",
};

function SignIn(props) {
  const { isDarkMode } = useThemeContext();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [openModel, setOpenModel] = React.useState(false);
  const handleCloseModel = () => setOpenModel(false);
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });
  const [callBack, setCallBack] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 600 : false
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (alert.message !== "") {
      setOpen(true);
    }
  }, [alert]);

  const getData = async (e) => {
    try {
      setCallBack(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      // eslint-disable-next-line
      const { data, status } = await axios.post(
        `${url}/user/login`,
        { email: e.email, password: e.password },
        config
      );

      const { _id } = data;
      props.login(JSON.stringify(data), _id);

      // Redirect based on user role
      const userType = (data.userType || data.role || '').toString().toLowerCase();
      const redirectPath = userType === 'technician' ? '/jobs' : '/dashboard';
      navigate(redirectPath);
      setCallBack(false);
    } catch (error) {
      setCallBack(false);
      setAlert({
        showAlert: true,
        severity: "error",
        message: `${error.response.data.message ? error.response.data.message : error.response.data ? error.response.data : "Invalid credentials"}`,
      });

      setTimeout(() => {
        setAlert({
          showAlert: false,
          severity: "success",
          message: "",
        });
      }, 5000);
    }
  };

  function handleClose() {
    setOpen(false);
    setAlert({
      ...alert,
      showAlert: false,
      severity: "",
      message: "",
    });
  }
  return (
    <Box sx={{ backgroundColor: isDarkMode ? "#0f172a" : "#f8fafc", minHeight: "100vh", pt: "80px", fontFamily: "Inter, system-ui, sans-serif" }}>
      <Navbar hideUser hideMenu />
      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={alert.severity}
          sx={{
            fontSize: "16px",
          }}
        >
          {alert.message}
        </Alert>
      </Snackbar>

      <Box display="flex" justifyContent="center" mb={2}>
        <Box display="flex" alignItems="center" gap={1}>
          <PersonIcon sx={{ color: "#3b82f6", fontSize: 40 }} />
          <Typography sx={{ color: "#0f172a", fontWeight: 700, fontSize: 28 }}>Sign In</Typography>
        </Box>
      </Box>

      <Box display="flex" justifyContent="center">
        <Card sx={{ borderRadius: "12px", border: "1px solid #e5e7eb", width: { xs: 340, sm: 420 }, p: 2 }}>
          <CardContent>
            <Grid container direction="column" alignItems="stretch">
              <Formik
                initialValues={initialValues}
                onSubmit={getData}
                validationSchema={SignInSchema}
              >
                {({ errors, isValid, touched, dirty }) => (
                  <Form style={formStyles}>
                    <Typography sx={{ color: "#64748b", mb: 1 }}>
                      Log in to your account
                    </Typography>

                    <Grid item>
                      <Field
                        sx={fieldStyles}
                        name="email"
                        label="Email"
                        as={TextField}
                        variant="outlined"
                        required
                        size="small"
                        margin="dense"
                        error={Boolean(errors.email) && Boolean(touched.email)}
                        helperText={Boolean(touched.email) && errors.email}
                      ></Field>
                    </Grid>

                    <Grid item>
                      <Field
                        sx={fieldStyles}
                        name="password"
                        label="Password"
                        as={TextField}
                        variant="outlined"
                        type="password"
                        required
                        size="small"
                        margin="dense"
                        autoComplete="current-password"
                        error={Boolean(errors.password) && Boolean(touched.password)}
                        helperText={Boolean(touched.password) && errors.password}
                      ></Field>
                    </Grid>

                    <Grid item sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Button
                        sx={{
                          textTransform: "none",
                          background: "linear-gradient(to right, #3b82f6, #2563eb)",
                          "&:hover": { background: "linear-gradient(to right, #2563eb, #1d4ed8)" },
                          borderRadius: "8px",
                          fontSize: "0.95rem",
                          fontWeight: "700",
                          height: "2.25rem",
                          marginTop: "1rem",
                          marginBottom: "1rem",
                          color: "#fff",
                          width: { xs: '220px', sm: '240px' },
                        }}
                        variant="contained"
                        disabled={!dirty || !isValid || callBack}
                        type="submit"
                        size="medium"
                      >
                        Sign In
                      </Button>
                      <ChangePassword open={openModel} onClose={handleCloseModel} />
                    </Grid>

                    <Grid item sx={{ textAlign: 'center' }}>
                      <Typography
                        onClick={() => setOpenModel(true)}
                        sx={{ color: '#3b82f6', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}
                      >
                        Forgot password?
                      </Typography>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default connect(null, { login })(SignIn);
